import { jwtDecode } from "jwt-decode";

export const vehicleTypes = [
  { value: "BASIC", label: "BASIC" },
  { value: "CONFORT", label: "CONFORT" },
  { value: "PREMIUM", label: "PREMIUM" },
  { value: "SUPER_ECONOMY_SANS_CLIM", label: "SUPER ECONOMY SANS CLIM" },
  { value: "FAMILIALE_7_PLACES_PREMIUM", label: "FAMILIALE 7 PLACES PREMIUM" },
  { value: "TOYOTA_PRADO_TXL", label: "TOYOTA PRADO TXL" },
  { value: "MERCEDEZ_GL_500", label: "MERCEDEZ GL 500" },
  { value: "LANDCRUISER_GXR_2022", label: "LANDCRUISER GXR 2022" },
  { value: "TOYOTA_FORTUNER_PRADO_TX", label: "TOYOTA FORTUNER - PRADO TX" },
];

export function rejectionReasons() {
  const rejectionReasons = [
    { label: "Destination Too Far", value: "DESTINATION_TOO_FAR" },
    { label: "High Traffic Area", value: "HIGH_TRAFFIC_AREA" },
    { label: "Personal Emergency", value: "PERSONAL_EMERGENCY" },
    { label: "Vehicle Issue", value: "VEHICLE_ISSUE" },
    { label: "Not Safe Area", value: "NOT_SAFE_AREA" },
    { label: "Low Fare", value: "LOW_FARE" },
    { label: "Excessive Wait Time", value: "EXCESSIVE_WAIT_TIME" },
    { label: "Passenger Behavior", value: "PASSENGER_BEHAVIOR" },
    { label: "Trip Already Accepted", value: "TRIP_ALREADY_ACCEPTED" },
    { label: "Route Too Long", value: "ROUTE_TOO_LONG" },
    { label: "Other", value: "OTHER" },
  ];
  return rejectionReasons;
}

const roleColors = {
  SUPER_ADMIN: "#2B6FF2",
  ADMIN: "#0ED27D",
  SERVICE_CLIENT: "orange",
  FINANCE: "#7ab99b",
  DISPATCH: "#000",
};

export function getRoleColor(role) {
  return roleColors[role] || "gray";
}

export function hasAccess(roles) {
  const token = localStorage.getItem("access_token");
  if (token) {
    const decoded = jwtDecode(token);
    if (roles.includes(decoded?.role)) {
      return true;
    }
  }
  return false;
}

export function getRejectionReason(reason) {
  let message;
  switch (reason) {
    case "DESTINATION_TOO_FAR":
      message =
        "The destination is too far from the driver's current location.";
      break;
    case "HIGH_TRAFFIC_AREA":
      message = "The trip involves a high traffic area, causing delays.";
      break;
    case "PERSONAL_EMERGENCY":
      message =
        "The driver is unable to take the trip due to a personal emergency.";
      break;
    case "VEHICLE_ISSUE":
      message = "The driver is experiencing a vehicle issue.";
      break;
    case "NOT_SAFE_AREA":
      message = "The driver is concerned about safety in the area.";
      break;
    case "LOW_FARE":
      message = "The fare is too low for the trip.";
      break;
    case "EXCESSIVE_WAIT_TIME":
      message = "The driver has been waiting too long for the passenger.";
      break;
    case "PASSENGER_BEHAVIOR":
      message = "The driver has concerns about the passenger's behavior.";
      break;
    case "TRIP_ALREADY_ACCEPTED":
      message = "The trip was already accepted by another driver.";
      break;
    case "ROUTE_TOO_LONG":
      message = "The route is too long for the driver to accept.";
      break;
    case "OTHER":
      message =
        "The driver has another unspecified reason for rejecting the trip.";
      break;
    default:
      message = "Unknown reason for trip rejection.";
  }

  return message;
}

export const currencyCodes = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "FOK",
  "GBP",
  "GEL",
  "GGP",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "IMP",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JEP",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KID",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TVD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "UYU",
  "UZS",
  "VES",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW",
  "ZWL",
];
